import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  colours as colourHelpers,
  metrics as metricHelpers
} from '../helpers';

import MetricsSelectorContainer
  from './../Containers/MetricsSelectorContainer';
import CaseMetricsDurationChartContainer
  from './../Containers/CaseMetricsDurationChartContainer';
import CaseMetricsHitCountChartContainer
  from './../Containers/CaseMetricsHitCountChartContainer';
import CaseMetricsTimingChartContainer
  from './../Containers/CaseMetricsTimingChartContainer';
import CaseMetricsDeltasContainer
  from './../Containers/CaseMetricsDeltasContainer';
import MetricsJobInfoContainer
  from './../Containers/MetricsJobInfoContainer';
import CaseMetricsDispatcherContainer
  from './../Containers/CaseMetricsDispatcherContainer';
import CaseMetricsGenericMetricChartContainer
  from '../Containers/CaseMetricsGenericMetricChartContainer';

import { pageTypes } from './../helpers';
import ConditionalComponent from '../Components/ConditionalComponent';

const CaseMetricsComponent = ({ isAuthenticated }) => {

  return (
    <div>
      <ConditionalComponent condition={!isAuthenticated}>
        <center>
          <p style={{ color:'red' }}>
            Performance chart trends may include
            jobs which are not performance dependent if not logged in with
            JIRA credentials.
          </p>
        </center>
      </ConditionalComponent>
      <Row>
        <Col sm={10} md={6} mdOffset={1}>
          <Row>
            <MetricsSelectorContainer pageType={pageTypes.CASEMETRICS} />
          </Row>
          <Row>
            <CaseMetricsDispatcherContainer
              jumpDestination={pageTypes.ARTIFACTSMETRICS}
            />
          </Row>
        </Col>
        <Col md={5}>
          <MetricsJobInfoContainer pageType = {pageTypes.CASEMETRICS} />
        </Col>
      </Row>
      <Row>
        <Col md={10} mdOffset={1}>
          <CaseMetricsDeltasContainer />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <h2> Duration </h2>
          <CaseMetricsDurationChartContainer />
        </Col>
        <Col md={6}>
          <h2> Hit Count </h2>
          <CaseMetricsHitCountChartContainer />
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <h3> Source Counts </h3>
          <Row>
            <Col md={6}>
              <CaseMetricsGenericMetricChartContainer
                disablePointOptions
                getMetricFuncPerDataSet={[
                  (m) => m && m.ncf.sourceCount ? m.ncf.sourceCount : 0
                ]}
                overrideCaseMetricsPointOptions
                seriesColors={[colourHelpers.METRICS_CHARTS.NCF_DEFAULT]}
                seriesLabels={['NCF Source Count']}
              />
            </Col>
            <Col md={6}>
              <CaseMetricsGenericMetricChartContainer
                disablePointOptions
                getMetricFuncPerDataSet={[
                  (m) => m && m.ncf.sourceAttributeCount ? m.ncf.sourceAttributeCount : 0
                ]}
                overrideCaseMetricsPointOptions
                seriesColors={[colourHelpers.METRICS_CHARTS.NCF_DEFAULT]}
                seriesLabels={['NCF Source Attribute Count']}
              />
            </Col>
          </Row>
        </Col>
        <Col md={4} sm={12}>
          <h3> Case Size </h3>
          <CaseMetricsGenericMetricChartContainer
            getMetricFuncPerDataSet={[
              (m) => m && m.ccf.caseSize ? m.ccf.caseSize / 1e9 : 0,
              (m) => m && m.ncf.caseSize ? m.ncf.caseSize / 1e9 : 0
            ]}
            seriesColors={[
              colourHelpers.METRICS_CHARTS.CCF_DEFAULT,
              colourHelpers.METRICS_CHARTS.NCF_DEFAULT
            ]}
            seriesLabels={[
              'CCF Case Size',
              'NCF Case Size'
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col md={8} mdOffset={2}>
          <h2> Resource Usage </h2>
          <Row>
            <Col md={6}>
              <CaseMetricsGenericMetricChartContainer
                disablePointOptions
                getMetricFuncPerDataSet={[
                  (m) => m && m.ncf.resourceUsage ?
                    m.ncf.resourceUsage[metricHelpers.AVERAGECPUUSAGE] :
                    0,
                  (m) => m && m.ncf.resourceUsage ?
                    m.ncf.resourceUsage[metricHelpers.HIGHESTCPUUSAGEPEAK] :
                    0
                ]}
                seriesColors={[
                  colourHelpers.METRICS_CHARTS.CCF_DEFAULT,
                  colourHelpers.METRICS_CHARTS.NCF_DEFAULT
                ]}
                seriesLabels={[
                  'NCF Average CPU Usage (%)',
                  'NCF Highest CPU Usage Peak (%)'
                ]}
              />
            </Col>
            <Col md={6}>
              <CaseMetricsGenericMetricChartContainer
                disablePointOptions
                getMetricFuncPerDataSet={[
                  (m) => m && m.ncf.resourceUsage ?
                    m.ncf.resourceUsage[metricHelpers.AVERAGERAMUSAGE] :
                    0,
                  (m) => m && m.ncf.resourceUsage ?
                    m.ncf.resourceUsage[metricHelpers.HIGHESTRAMUSAGEUSAGEPEAK] :
                    0
                ]}
                seriesColors={[
                  colourHelpers.METRICS_CHARTS.CCF_DEFAULT,
                  colourHelpers.METRICS_CHARTS.NCF_DEFAULT
                ]}
                seriesLabels={[
                  'NCF Average RAM Usage (Bytes)',
                  'NCF Highest RAM Usage Peak (Bytes)'
                ]}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <h3> Detailed Timings </h3>
          <Col md={6} sm={12}>
            <h2> NCF </h2>
            <CaseMetricsTimingChartContainer stacked />
          </Col>
          <Col md={6} sm={12}>
            <h2> CCF </h2>
            <CaseMetricsTimingChartContainer isCcf stacked />
          </Col>
        </Col>
      </Row>
    </div>
  );
};

CaseMetricsComponent.propTypes = { isAuthenticated: PropTypes.bool.isRequired };

export default CaseMetricsComponent;


// WEBPACK FOOTER //
// src/Components/CaseMetricsComponent.jsx